<template>
  <SortSearch default-sort="latest" dimension="LatestVectors" :force-experience="getDesign" />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  computed: {
    ...mapGetters('experience', ['getDesign'])
  },
  nuxtI18n: {
    paths: {
      en: '/design/latest-vectors',
      es: '/design/ultimos-vectores',
      pt: '/design/novos-vetores',
      de: '/design/neue-vektoren'
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>
